import * as React from 'react';
import { Checkbox } from '@cian/ui-kit';
import { UIText3 } from '@cian/ui-kit/typography';
import { useDeviceType } from '@cian/ui-kit/responsive/hooks/useDeviceType';
import clsx from 'clsx';

import * as styles from './styles.css';

interface IAgreementsBlockProps {
  isChecked?: boolean;
  toggleCheckbox(): void;
  privacyPolicyUrl: string;
  personalDataAgreement: string;
  marketingAgreementUrl?: string | null;
  buttonText: string;
}

export const AgreementsBlock: React.FC<React.PropsWithChildren<IAgreementsBlockProps>> = ({
  isChecked,
  toggleCheckbox,
  privacyPolicyUrl,
  personalDataAgreement,
  marketingAgreementUrl,
  buttonText,
}) => {
  const deviceType = useDeviceType();

  return (
    <div className={clsx(styles['legal'], styles[deviceType])}>
      {marketingAgreementUrl && (
        <div className={styles['marketing']} data-name="AgreementMarketing">
          <Checkbox checked={isChecked} onChange={toggleCheckbox} dataTestId={'marketing_agreement'} />
          <UIText3 color="text-secondary-default">
            Соглашаюсь на{' '}
            <a href={marketingAgreementUrl} className={styles['link']} target="_blank" rel="noopener noreferrer">
              рассылки и звонки
            </a>
          </UIText3>
        </div>
      )}
      <div className={styles['secury']}>
        <UIText3 color="text-secondary-default">
          {`Нажимая «${buttonText}», я даю`}{' '}
          <a href={personalDataAgreement} target="_blank" className={styles['link']} rel="noreferrer">
            Согласие на обработку персональных данных
          </a>{' '}
          в соответствии с{' '}
          <a href={privacyPolicyUrl} target="_blank" className={styles['link']} rel="noreferrer">
            Политикой конфиденциальности
          </a>
        </UIText3>
      </div>
    </div>
  );
};

AgreementsBlock.displayName = 'AgreementsBlock';
